<script setup lang="ts">
// 위기 안내(planning 17-1 P0). 막지 않고 안내만. 로케일별 상담처.
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t, locale } = useI18n()
const emit = defineEmits<{ close: [] }>()

const KO = [
  { name: '자살예방 상담전화', contact: '☎ 109 (24시간)' },
  { name: '정신건강 위기상담', contact: '☎ 1577-0199' },
  { name: '청소년 전화', contact: '☎ 1388' },
]
const EN = [
  { name: '988 Suicide & Crisis Lifeline', contact: 'Call or text 988 (US, 24/7)' },
  { name: 'Crisis Text Line', contact: 'Text HOME to 741741' },
]
const list = computed(() => (locale.value === 'en' ? EN : KO))
</script>

<template>
  <div class="crisis" @click.self="emit('close')">
    <div class="crisis-card">
      <h3>{{ t('crisis.title') }}</h3>
      <p class="crisis-msg">{{ t('crisis.msg') }}</p>
      <div class="crisis-list">
        <div v-for="r in list" :key="r.name" class="crisis-item"><b>{{ r.name }}</b><span>{{ r.contact }}</span></div>
      </div>
      <p class="crisis-note">{{ t('crisis.note') }}</p>
      <button class="setp-btn" @click="emit('close')">{{ t('crisis.close') }}</button>
    </div>
  </div>
</template>
